<template>
  <v-app>
    <v-app-bar clipped-left absolute app height="100">
      <v-container>
        <v-row align="center">
          <span class="d-flex d-sm-none">
            <v-app-bar-nav-icon @click="drawer = !drawer" />
          </span>
          <v-app-bar-title class="ml-3 logo-text w-auto">
            {{ pkg.project }}
          </v-app-bar-title>
          <v-spacer />
          <v-toolbar-items>
            <language-switcher />
          </v-toolbar-items>
          <v-toolbar-items class="d-none d-sm-flex">
            <v-btn-toggle>
              <v-btn
                v-for="menuItem in visibleMenuItems"
                :key="menuItem.title"
                v-bind="menuItem.props"
              >
                {{ menuItem.title }}
              </v-btn>
            </v-btn-toggle>
          </v-toolbar-items>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" temporary app>
      <v-list nav dense>
        <v-list-item
          v-for="menuItem in visibleMenuItems"
          :key="menuItem.title"
          v-bind="menuItem.props"
        >
          <template #prepend>
            <v-icon>{{ menuItem.icon }}</v-icon>
          </template>
          <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useTheme} from 'vuetify';
import {useStore} from 'vuex';

import LanguageSwitcher from '@/Foundation/components/LanguageSwitcher.vue';
import {getLocale, getTheme} from '@/Foundation/helpers/storage';

import pkg from '../../package.json';

const store = useStore();
const {t, locale} = useI18n();
const theme = useTheme();

const drawer = ref(false);

const menuItems = ref([
  {title: t('menu.home'), icon: 'mdi-home', visible: true, props: {to: '/'}},
  {title: t('menu.sign_in'), icon: 'mdi-login', visible: true, props: {to: '/sign-in'}},
  {title: t('menu.cabinet'), icon: 'mdi-account', visible: false, props: {href: '/cabinet/dashboard'}},
]);

const visibleMenuItems = computed(() => {
  return menuItems.value.filter(item => item.visible);
});

const updateMenuVisibility = () => {
  const signInIdx = menuItems.value.findIndex(item => item.props.to === '/sign-in');
  const cabinetIdx = menuItems.value.findIndex(item => item.props.href === '/cabinet/dashboard');

  if (store.state.auth.signedIn) {
    if (cabinetIdx !== -1) menuItems.value[cabinetIdx].visible = true;
    if (signInIdx !== -1) menuItems.value[signInIdx].visible = false;
  } else {
    if (cabinetIdx !== -1) menuItems.value[cabinetIdx].visible = false;
    if (signInIdx !== -1) menuItems.value[signInIdx].visible = true;
  }
};

onMounted(async () => {
  await store.dispatch('auth/identify');
  updateMenuVisibility();
  theme.change(getTheme());
  locale.value = getLocale() as typeof locale.value;
});
</script>

<script lang="ts">
export default {
  name: 'App',
};
</script>